module.exports = __webpack_public_path__ + "static/Alina-b92f4ac3edd1e43ad073851899cf6d13.jpg";